import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { LexileDetailsReportData } from 'teacher-ui-client/components/giraffe/charts/lexile-details/student'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import fillMonths from 'teacher-ui-client/utils/student-events/fill-months'

export interface LexileDetailsStudentResponse {
  lexile_level_by_month_events_summary: {
    data: [
      {
        category: 'lexile_level'
        count: number
      },
      {
        category: 'lexile_growth'
        count: number
      },
    ]
  }
  lexile_level_by_month_events: {
    month: string
    lexile: number
  }[]
}

export async function lexileDetailsStudent(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<LexileDetailsReportData>> {
  if (isEmpty(statsScope.ids)) return Promise.resolve(null)

  const url = this.buildUrl('lexile_level_by_month_events', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<LexileDetailsStudentResponse>(url, query)
  if (!data) return null

  const { lexile_level_by_month_events_summary: summaryData, lexile_level_by_month_events: monthsData } = data
  if (monthsData.length === 0) return null

  const lexile_level = summaryData.data.find((d) => d.category === 'lexile_level')!.count
  const lexile_growth = summaryData.data.find((d) => d.category === 'lexile_growth')!.count

  return {
    summary: {
      lexile_level,
      lexile_growth,
    },
    months: fillMonths(monthsData, period, {
      lexile: null,
    }),
  }
}
